// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__gWCay","dashboard":"Error_dashboard__Z9DeT","error-cta":"error-cta","icon":"Error_icon__Krgk1","title":"Error_title__fr_on"};